module.exports = __webpack_public_path__ + "media/v2/components/Contests/shared/Image/like-2f64391ab9f77167ba792e9e076c17ed.svg";